export default __webpack_public_path__ + "static/media/WNo.8-8.247136a0.jpg";